import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { SoundCloudStandalone } from "./components/SoundCloudStandalone";
import "./styles.css";

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js"));
}

const RootApp = window.location.hostname.toLowerCase() === "soundcloud.nkriz.ir" ? SoundCloudStandalone : App;
createRoot(document.getElementById("root")!).render(<StrictMode><RootApp /></StrictMode>);
